var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [_c("approved-access"), _c("pending-access"), _c("shared-with-me")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }